(function() {
    'use strict';

    angular
        .module('atheer.smartFlow', [

        ]);
})();
